import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * `AUTH-07` — token vencido conta como não autenticado. `returnUrl` sai do `state`, que é o
 * destino: `router.url` ainda é a tela de onde se vem (na abertura, `/`).
 */
function exigirSessao(state: RouterStateSnapshot): boolean {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  auth.clearSession();
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
}

export const authGuard: CanActivateFn = (_rota, state) => exigirSessao(state);

/**
 * O `canActivate` do grupo logado só roda ao entrar nele: navegar entre as telas filhas não o
 * repete, e o prazo vencia com o sistema aberto sem ninguém conferir. Este roda a cada tela.
 */
export const authChildGuard: CanActivateChildFn = (_rota, state) => exigirSessao(state);
